import React from "react";
import {Picker} from "emoji-mart";

import {useLocalization} from "../../../customHooks/useContextLocalization";
import {useReduxData} from "../../customHooks/useContextReduxData";
import {setFixedChildrenValues} from "../../utils/figureHierarchy";
import getTimeElapsedSince from "../getTimeElapsedSince";

import "emoji-mart/css/emoji-mart.css";
import {useMapDispatch} from "../../customHooks/useContextMapDispatch";


export default function EmojiPicker({rerenderFloatingMenuItem}) {
    const locale = useLocalization();
    const {getFiguresUpdatedOn, selectedFigureUuidsWithoutArrows, startTime} = useReduxData();
    const figures = getFiguresUpdatedOn([
        "addPolygon",
        "addPolyline",
        "addPointFeature",
        "addGroup",
        "changeObjectParentUuid",
        "clearState",
        "deleteFigure",
        "disbandGroup"
    ]);

    const mapDispatch = useMapDispatch();

    const handleSelect = emoji => {
        selectedFigureUuidsWithoutArrows.map(uuid => figures.get(uuid).get("tool").split("-")[0] !== "c" && setFixedChildrenValues(
            figures,
            uuid,
            ["emoji"],
            mapDispatch,
            [[{emoji: emoji}]],
            "addFigureEmoji",
            getTimeElapsedSince(startTime)
        ));
        rerenderFloatingMenuItem();
    };

    return <div className="floating-menu-emoji-picker">
        <Picker
            set="google"
            i18n={locale?.get.studio.emojiPicker}
            skin={1}
            emojiSize={22}
            showPreview={false}
            showSkinTones={false}
            onSelect={handleSelect}
        />
    </div>;
}
